import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useAppDispatch } from '../../../../hooks';
import { CmdArea } from '../../common/CmdArea';
import { Number } from '../../common/Number';
import { String } from '../../common/String';
import { zigbeeAddGroup } from '../../../../actions/zigbee/commands/Groups/ZigbeeAddGroup';
import { zigbeeViewGroup } from '../../../../actions/zigbee/commands/Groups/ZigbeeViewGroup';
//import { zigbeeGetGroupMembership } from '../../../../actions/zigbee/commands/Groups/ZigbeeGetGroupMembership';
import { zigbeeRemoveGroup } from '../../../../actions/zigbee/commands/Groups/ZigbeeRemoveGroup';
const CmdAddGroup = (props) => {
    const [groupId, setGroupId] = useState(0);
    const [groupName, setGroupName] = useState('');
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeAddGroup(props.nid, props.eid, { groupId, groupName }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Group id ", _jsx(Number, { value: groupId, setValue: setGroupId })] }), _jsx("br", {}), _jsxs("label", { children: ["Group name ", _jsx(String, { value: groupName, setValue: setGroupName })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Add Group" })] }));
};
const CmdViewGroup = (props) => {
    const [groupId, setGroupId] = useState(0);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeViewGroup(props.nid, props.eid, { groupId }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Group id ", _jsx(Number, { value: groupId, setValue: setGroupId })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "View Group" })] }));
};
/*
const CmdGetGroupMembership = props => {
    const [groupCount, setGroupCount] = useState<number>(0);
    const [groupName, setGroupName] = useState<string>('');

    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeGetGroupMembership(props.nid, props.eid, {groupCount, groupList}));
    }

    return (<CmdArea>
                <label>Group id <Number value={groupId} setValue={setGroupId} /></label>
                <br />
                <label>Group name <String value={groupName} setValue={setGroupName} /></label>
                <br />
                <button onClick={onClick}>Add Group</button>
            </CmdArea>)
}
*/
const CmdRemoveGroup = (props) => {
    const [groupId, setGroupId] = useState(0);
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeRemoveGroup(props.nid, props.eid, { groupId }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: ["Group id ", _jsx(Number, { value: groupId, setValue: setGroupId })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Remove Group" })] }));
};
export const CommandsGroups = props => {
    return (_jsx(React.Fragment, { children: _jsxs("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '1em' }, children: [_jsx(CmdAddGroup, Object.assign({}, props)), _jsx(CmdViewGroup, Object.assign({}, props)), _jsx(CmdRemoveGroup, Object.assign({}, props))] }) }));
};
